import { render, staticRenderFns } from "./BookBankEntity.vue?vue&type=template&id=72bce47c&scoped=true"
import script from "./BookBankEntity.vue?vue&type=script&lang=js"
export * from "./BookBankEntity.vue?vue&type=script&lang=js"
import style0 from "./BookBankEntity.vue?vue&type=style&index=0&id=72bce47c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bce47c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bce47c')) {
      api.createRecord('72bce47c', component.options)
    } else {
      api.reload('72bce47c', component.options)
    }
    module.hot.accept("./BookBankEntity.vue?vue&type=template&id=72bce47c&scoped=true", function () {
      api.rerender('72bce47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BookBankEntity.vue"
export default component.exports